module.exports = __webpack_public_path__ + "media/site_templates/www.furnituredisposal.com.au/images/our_services_2-e69c4e90048748359cda7b12db104a6a.jpg";